//our root app component
import {Component, NgModule, VERSION, Pipe, PipeTransform,OnInit } from '@angular/core'
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'

@Component({
  selector: 'app-testkeyboard',
  templateUrl: './testkeyboard.component.html',
  styleUrls: ['./testkeyboard.component.css']
})
export class TestkeyboardComponent implements OnInit {
 
  ngOnInit() {}
  searchText='hola';
  actualText = 'holaaaa lorem ipsum bli bla ble';
  cambioinput(texto){
    console.log('texto');
  }
}
